var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map",style:({height:_vm.wapperHeight})},[_c('ve-map',{attrs:{"height":_vm.wapperHeight,"data":_vm.chartData,"extend":_vm.percentExtend,"color":"#fff","settings":_vm.chartSettings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }